var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterFacebookIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.025641)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 39,
    height: 39,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAAAnCAMAAAC7faEHAAAAkFBMVEUAAAD/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDT/MDRHNVveAAAAL3RSTlMA2O1ekIAI6dSzopZfKyID9eXdyLernF1VTxP59vHPbWVaRzgyHw3BpZmHQhv3JVn3xoQAAAFISURBVDjLnZTZkoIwEEXbCIosKiib+4rbzPT//92EFNGGDlDleaFy69SFTlLAV8xO9sQZb8VgaeejViuwQvwwflyM1irBJu4P13KBnHna1Gw0Y9U1D9u4s7b+xhN2cdRa8YuMnWfbTy/CEj21y+fMQWGp1RIUV2QEVUNCl3xWG4D2YazOdMu8q5Iu5/MEFetCLl9MG6tjdEiSGffOKb0jTTwZLM3egSYLGQz4e5kXyUAgZS2EWJReJiSbKhUymCNlMJKobZDP2ULvO+tzgBKSvqjeR7WpTkM27456AZ33iZRwmPq56vL9NNHpw3j5NqW3b17BmRqefaNPk0JfP+4NSTCBkr9e7wKKuMe76T9Bj3eFiqzTO8Abq8NzgXDnHp2VNTIvgQb+2uTtgTGNa15avjMAE2d3+7n3e4xf0MYqs26R2Kn6KXzDP5qRm6SH7Zg0AAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFacebookIcon);
export default __webpack_public_path__ + "static/media/footer-facebook-icon.4063de57c651cf9c9b8dd970728135b8.svg";
export { ForwardRef as ReactComponent };